import { render, staticRenderFns } from "./claimantBill.vue?vue&type=template&id=191b45bc&scoped=true&"
import script from "./claimantBill.vue?vue&type=script&lang=js&"
export * from "./claimantBill.vue?vue&type=script&lang=js&"
import style0 from "./claimantBill.vue?vue&type=style&index=0&id=191b45bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191b45bc",
  null
  
)

export default component.exports